function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RedeemAnimation = function RedeemAnimation(_ref) {
  var _redux$webView, _config$deals;
  var content = _ref.content,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    title = _ref.title,
    config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClicked = _useState2[0],
    setIsClicked = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCompleted = _useState6[0],
    setIsCompleted = _useState6[1];
  var internalWebview = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.internalWebview;
  var redeemNowButtonConfig = config === null || config === void 0 || (_config$deals = config.deals) === null || _config$deals === void 0 || (_config$deals = _config$deals.dealLayout) === null || _config$deals === void 0 ? void 0 : _config$deals.redeemNowButtonConfig;
  useEffect(function () {
    var timer1;
    var timer2;
    if (isClicked) {
      onClick();
      setIsLoading(true);
      timer1 = setTimeout(function () {
        setIsLoading(false);
        setIsCompleted(true);
        timer2 = setTimeout(function () {
          setIsClicked(false);
          setIsCompleted(false);
        }, 1000);
      }, 1000);
    }
    return function () {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [isClicked]);
  var handleClick = function handleClick() {
    setIsClicked(true);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "relative ".concat(internalWebview ? "flex justify-center items-center" : "", " w-full lg:w-auto"),
    children: [isLoading && /*#__PURE__*/_jsx("div", {
      className: " bg-white flex items-center justify-center lg:px-10",
      children: /*#__PURE__*/_jsxs("svg", {
        className: "text-primary h-10 w-10 text-center",
        viewBox: "0 0 200 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/_jsxs("defs", {
          children: [/*#__PURE__*/_jsxs("linearGradient", {
            id: "spinner-secondHalf",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0%",
              stopOpacity: "0",
              stopColor: "currentColor"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "100%",
              stopOpacity: "0.5",
              stopColor: "currentColor"
            })]
          }), /*#__PURE__*/_jsxs("linearGradient", {
            id: "spinner-firstHalf",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0%",
              stopOpacity: "1",
              stopColor: "currentColor"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "100%",
              stopOpacity: "0.5",
              stopColor: "currentColor"
            })]
          })]
        }), /*#__PURE__*/_jsxs("g", {
          strokeWidth: "8",
          children: [/*#__PURE__*/_jsx("path", {
            stroke: "url(#spinner-secondHalf)",
            d: "M 4 100 A 96 96 0 0 1 196 100"
          }), /*#__PURE__*/_jsx("path", {
            stroke: "url(#spinner-firstHalf)",
            d: "M 196 100 A 96 96 0 0 1 4 100"
          }), /*#__PURE__*/_jsx("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M 4 100 A 96 96 0 0 1 4 98"
          })]
        }), /*#__PURE__*/_jsx("animateTransform", {
          from: "0 0 0",
          to: "360 0 0",
          attributeName: "transform",
          type: "rotate",
          repeatCount: "indefinite",
          dur: "1300ms"
        })]
      })
    }), !isLoading && !isCompleted && /*#__PURE__*/_jsx("button", {
      onClick: handleClick,
      className: (redeemNowButtonConfig === null || redeemNowButtonConfig === void 0 ? void 0 : redeemNowButtonConfig.className) + "transition-all duration-300 ease-in-out w-full p-2  ".concat(fullWidth ? "lg:w-full mt-2" : "lg:w-auto", "  ").concat(internalWebview ? "w-full font-semibold" : "", " "),
      disabled: disabled,
      title: title,
      children: content
    }), isCompleted && /*#__PURE__*/_jsx("button", {
      className: redeemNowButtonConfig === null || redeemNowButtonConfig === void 0 ? void 0 : redeemNowButtonConfig.className,
      children: /*#__PURE__*/_jsx("svg", {
        className: "h-6 w-6 text-white",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/_jsx("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M5 13l4 4L19 7"
        })
      })
    })]
  });
};
export default RedeemAnimation;